module.exports = __webpack_public_path__ + "static/media/img-top-left.7317c160.png";